// Error taxonomy (§0.5). Only InfraError is retried. A StateError thrown inside pure `step` is
// deterministic and will recur on re-simulation — fatal-after-dump (§16.4), never retried.

/** Malformed wire/log data (bad framing, truncated buffer, unknown type). */
export class ProtocolError extends Error {
  override readonly name = 'ProtocolError';
  constructor(message: string) {
    super(message);
  }
}

/** Well-formed but illegal values (out-of-range mode, illegal transition request from a client). */
export class ValidationError extends Error {
  override readonly name = 'ValidationError';
  constructor(message: string) {
    super(message);
  }
}

/** Illegal state transition inside the sim — a bug. Deterministic; recurs on re-simulation. */
export class StateError extends Error {
  override readonly name = 'StateError';
  constructor(message: string) {
    super(message);
  }
}

/** Adapter/infra failure (WS, DB, SMTP, LiveKit). The only retried category. */
export class InfraError extends Error {
  override readonly name = 'InfraError';
  constructor(message: string) {
    super(message);
  }
}
